var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.026,
    height: 34.502,
    viewBox: "0 0 47.026 34.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "low-gauge-linear-gradient",
    x1: 0.935,
    y1: 0.744,
    x2: 0.04,
    y2: 0.749,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64f884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1fce7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Low_Guage",
    "data-name": "Low Guage",
    transform: "translate(-766.694 -507.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2729",
    "data-name": "Group 2729",
    transform: "translate(-22.113 -0.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_39",
    "data-name": "Union 39",
    d: "M41.867,22a18.191,18.191,0,0,0-3.725-10.476l3.225-2.54A22.215,22.215,0,0,1,46,22ZM0,22A22.2,22.2,0,0,1,5.471,7.966l3.143,2.628A18.212,18.212,0,0,0,4.135,22ZM23.994,4.078V.021A23.141,23.141,0,0,1,40.781,8.257L37.561,10.8A18.976,18.976,0,0,0,23.994,4.078Zm-17.9,3.2A23.18,23.18,0,0,1,23,0h.051V4.052H23A19,19,0,0,0,9.24,9.906Z",
    transform: "translate(789.32 508.712)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#low-gauge-linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730",
    transform: "matrix(0.588, -0.809, 0.809, 0.588, 192.236, 761.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_605",
    "data-name": "Polygon 605",
    d: "M1,0,2,24H0Z",
    transform: "translate(539 328)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_671",
    "data-name": "Ellipse 671",
    transform: "translate(539 347)",
    fill: "#fff",
    stroke: "#2e2e2e",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.875,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "LOW",
    transform: "translate(781.707 540)",
    fill: "#2e2e2e",
    fontSize: 8,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LOW")), /*#__PURE__*/React.createElement("path", {
    id: "Path_167211",
    "data-name": "Path 167211",
    d: "M1409.534,146.7a18.984,18.984,0,0,1,13.567,6.719l3.218-2.538a23.138,23.138,0,0,0-16.785-8.236V146.7Z",
    transform: "translate(-618.331 365.373)",
    fill: "#f2f2f2",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167212",
    "data-name": "Path 167212",
    d: "M1463.451,180.025a18.172,18.172,0,0,1,3.722,10.475h4.134a22.162,22.162,0,0,0-4.635-13.015l-3.22,2.54Z",
    transform: "translate(-658.1 339.497)",
    fill: "#f2f2f2",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167213",
    "data-name": "Path 167213",
    d: "M1344.451,152.468a19,19,0,0,1,13.761-5.853h.053v-4.051h-.053a23.161,23.161,0,0,0-16.906,7.273l3.145,2.631Z",
    transform: "translate(-568.005 365.436)",
    fill: "#f2f2f2",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowGauge);
export default __webpack_public_path__ + "static/media/low-gauge.6fe02f22bd6d839ef9c8da42d53cf56b.svg";
export { ForwardRef as ReactComponent };